import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=d1a0aee2&scoped=true"
import script from "./brandDetail.vue?vue&type=script&lang=js"
export * from "./brandDetail.vue?vue&type=script&lang=js"
import style0 from "./brandDetail.vue?vue&type=style&index=0&id=d1a0aee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a0aee2",
  null
  
)

export default component.exports